import React from 'react';
import Classes from './Reports.module.css';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
// import DownloadIcon from './DownloadIcon';
import DownloadIcon from '@mui/icons-material/Download';
import jsPDF from 'jspdf';

export default function TableRow({ value, handleOpenModal, generatePDF, monthYear,  reportsForMonth, dateRange,
  firstReport, lastReport
}) {
  const navigateTo = useNavigate();
  console.log(dateRange);


  return (
    <>
      <div className={Classes.customerRow}>
        <div
          className={`${Classes.customerInfo} ${Classes.colCustomer}`}
          style={{ cursor: 'pointer' }}
          onClick={() => handleOpenModal(value)}
        >
          <h5>
            Exposure Report: {monthYear?.replace('-', ' ')}
          </h5>
        </div>
        <div className={`${Classes.spendings} ${Classes.colSpendings}`}>
          <h5>{`${new Date(
            firstReport?.createdAt
          ).toLocaleDateString()} - ${new Date(
            lastReport?.updatedAt
          ).toLocaleDateString()}`}</h5>
        </div>
        <div
          className={`${Classes.bookings} ${Classes.colBookings}`}
        >
          <h5
            style={{ color: '#006B32', cursor: 'pointer' }}
            onClick={() => navigateTo(`/report/${monthYear}`)}
          >
            View
          </h5>
        </div>
        <div
          className={`${Classes.dateJoined} ${Classes.colDate}`}
          style={{ display: 'flex', justifyContent: 'end', gap: '8px' }}
        >
          <IconButton
            onClick={() => generatePDF(monthYear, reportsForMonth)}
          >
            <DownloadIcon height="18px" width="18px" fill="#006B32" />
          </IconButton>
        </div>
      </div>

      <div className={Classes.customerRowMobile}>
        <div className={`${Classes.flexBetween} ${Classes.mb5}`}>
          <div className={Classes.flexAlign5}>
            <h4>Report:</h4>
            <h5>Exposure Report: {monthYear?.replace('-', ' ')}</h5>
          </div>
          <div className={Classes.flexAlign10}>
            <h5
              style={{ color: '#006B32', cursor: 'pointer' }}
              onClick={() => navigateTo(`/report/${monthYear}`)}
            >
              View
            </h5>
          </div>
        </div>
        <div className={`${Classes.flexAlign5} ${Classes.mb5}`}>
          <h4>Date:</h4>
          <h5>{`${new Date(
            firstReport?.createdAt
          ).toLocaleDateString()} - ${new Date(
            lastReport?.updatedAt
          ).toLocaleDateString()}`}</h5>
        </div>
        <h4>Download report:</h4>
        <div className={Classes.flexAlign5}>
          <IconButton
            onClick={() => generatePDF(monthYear, reportsForMonth)}
          >
            <DownloadIcon height="18px" width="18px" fill="#006B32" />
          </IconButton>
        </div>
      </div>
    </>
  );
}